<template>
  <section class="download_wrapper">
    <a class="download_tips" href="#notification_wrapper" v-show="t(true,false)">
      Click to view download tips
    </a>

    <section class="download_totok">
      <div class="download_official">
        <p class="donwload_title" v-show="isPc">
          {{ t("Download the latest version of ToTok for Android","قم بتحميل أحدث إصدار من ToTok لنظام Android") }}
        </p>
        <p class="donwload_title_mobile" v-show="!isPc">
          {{ t("Download the latest version of ToTok for Android","قم بتحميل أحدث إصدار من ToTok لنظام Android") }}
        </p>
        <img
          v-if="this.t(true,false)"
          @click="viewDownload"
          src="../assets/img/ic_home_totok copy.png"
          alt="HD video call and voice chat for free "
          class="official_img"
        />
        <img
          v-else
          @click="viewDownload"
          src="../assets/img/download_button_ar.png"
          alt="HD video call and voice chat for free "
          class="official_img"
        />
        <p class="version">
          {{ t("Version ","الإصدار") }}
          {{ appInfo.appVersion }}</p>
        <p class="release_time">
          {{ t("Released on ","أصدر بتاريخ ") }}
          {{ appInfo.releaseTime }}</p>
        <div class="verified_by_wrapper">
          <img
            style="width: 15px;"
            src="../assets/img/ic_securityverified.png"
            alt="security icon"
          />
          <p class="verified_by_label">
              {{ t("Security verified by","تم التحقق من الأمان بواسطة") }}
           </p>
        </div>
        <div class="verified_box">
          <div
            class="verified_item"
            v-for="(iconItem, iconIdx) in securityList"
            :key="iconIdx"
          >
            <img
              class="verified_item_img"
              :src="iconItem.icon"
              :alt="iconItem.label"
            />
            <p class="verified_item_label">{{ iconItem.label }}</p>
          </div>
        </div>
      </div>
      <div class="download_available">
        <p class="avaliable_wrapper">
          {{ t("Also available on","متوفر أيضا على") }}
        </p>
        <ul>
          <li
            v-for="(downloadItem) in downloadIconList"
            :key="downloadItem.href"
            @click="viewPage(downloadItem.href, downloadItem.target)"
          >
            <img
              :src="downloadItem.imgrul"
              alt="download"
              class="download_icon"
            />
          </li>
        </ul>
        <p class="available_download_label">
          {{ t("ToTok is also available on the app stores of other phone makers such as Vivo.","يتوفر ToTok أيضاً في متاجر التطبيقات التابعة لشركات تصنيع الهواتف الأخرى مثل Vivo.") }}
        </p>
        <div
          style="padding-top:30px;"
          name="notification_wrapper"
          id="notification_wrapper"
        ></div>
      </div>
    </section>
    <div class="notification_box" v-show="t(true,false)">
      <section class="notification_wrapper">
        <div class="notification_container">
          <h3>ToTok Clarification Message to Latest Google Notification</h3>
          <p style="font-size: 16px; line-height: 26px; color: #555;">
            We have been informed that some of our Android users are receiving
            Google Play Store notifications not to install ToTok.
          </p>
          <img
            v-show="!isPc"
            src="../assets/img/downloadAndroidContent.png"
            alt="ToTok is secure and safe to download and use"
            class="android_download_pic"
          />
          <p
            style="
              font-size: 16px;
              line-height: 26px;
              color: #555;
              margin-bottom: 20px;
            "
          >
            We encourage you to ignore the Google Play Store message and
            continue to install and enjoy ToTok. Our app is secure and used
            safely by millions of people around the world. Please
            <a
              style="color: rgb(67, 120, 242);"
              href="https://totok.ai/security"
              >click here</a
            >
            to learn more about our privacy and security features.
          </p>
          <p
            style="
              font-size: 16px;
              line-height: 26px;
              color: #555;
              margin-bottom: 20px;
            "
          >
            Here are some important facts about ToTok:
          </p>
          <li
            style="
              font-size: 16px;
              line-height: 26px;
              color: #555;
              margin-bottom: 15px;
            "
          >
            ToTok has NO access to user SMS messages, meaning ToTok does NOT
            read or track user messages
          </li>
          <li
            style="
              font-size: 16px;
              line-height: 26px;
              color: #555;
              margin-bottom: 15px;
            "
          >
            ToTok does NOT view or upload any user photos
          </li>
          <li
            style="
              font-size: 16px;
              line-height: 26px;
              color: #555;
              margin-bottom: 15px;
            "
          >
            ToTok has NO access to user call history, meaning ToTok does not
            read or track user call history
          </li>
          <li
            style="
              font-size: 16px;
              line-height: 26px;
              color: #555;
              margin-bottom: 15px;
            "
          >
            ToTok does NOT listen to or upload any user audio recordings
          </li>
          <li
            style="
              font-size: 16px;
              line-height: 26px;
              color: #555;
              margin-bottom: 15px;
            "
          >
            ToTok has access to less user data than other leading instant
            messaging applications, such as WhatsApp and Telegram
          </li>
          <p
            style="
              font-size: 16px;
              line-height: 26px;
              color: #555;
              margin: 20px 0px;
            "
          >
            Please note that to make it easier for everyone to stay up to date
            on the recent coronavirus outbreak, we introduced “Coronavirus Live
            Updates”, a dedicated section that allows you to access the latest
            statistics and global news on the COVID-19 epidemic.
          </p>
          <p
            style="
              font-size: 16px;
              line-height: 26px;
              color: #555;
              margin: 20px 0px;
            "
          >
            Going forward, we will be launching a number of new features to
            enhance your experience on our app, including ToTok News, ToTok
            Games Center, and lots more!
          </p>
          <p
            style="
              font-size: 16px;
              line-height: 26px;
              color: #555;
              margin: 20px 0px;
            "
          >
            Thank you for joining the ToTok community!
          </p>
        </div>
        <img
          v-show="isPc"
          src="../assets/img/downloadAndroidContent.png"
          alt="ToTok is secure and safe to download and use"
          class="android_download_pic"
        />
      </section>
    </div>
    <Footer></Footer>
    <!-- <FootBanner v-show="!isPc && !isIOS"></FootBanner> -->
  </section>
</template>

<script>
import axios from "axios";
import Footer from "@/components/Footer.vue";
import FootBanner from "@/components/FootBanner.vue";
const ic_smsecurity = require("../assets/img/ic_smsecurity.png");
const ic_lookout = require("../assets/img/ic_lookout.png");
const ic_galaxystore = require("../assets/img/ic_download_galaxystore.png");
const ic_download_huawei_ar = require("../assets/img/appgallery_ar.png");
const ic_appgallery = require("../assets/img/ic_home_appgallery.png");
const ic_download_huawei = require("../assets/img/huaweilogo_download.png");
const ic_getapps = require("../assets/img/ic_download_getapps.png");
const ic_apkpure = require("../assets/img/ic_download_apkpure.png");
const ic_uptodown = require("../assets/img/ic_download_uptodown.png");
const ic_aptoide = require("../assets/img/ic_download_aptoide.png");
const ic_mcafee = require("../assets/img/ic_mcafee.png");
export default {
  name: "downloadAndroid",
  components: {
    Footer,
    FootBanner,
  },
  metaInfo() {
    return {
      title: "ToTok App download – Official channel for ToTok free download",
      meta: [
        {
          Description:
            "Check out the official download channel, install the latest version of ToTok for Android, and enjoy free video calls.",
        },
        { property: "og:title", content: "ToTok App download – Official channel for ToTok free download" },
        { property: "og:url", content: "https://totok.ai/download-android" },
        { property: "og:type", content: "website" },
        {
          property: "og:image",
          content: "https://static.totok.ai/pic/preview/free_unblocked_call.png",
        },
        {
          property: "og:description",
          content:
            "Check out the official download channel, install the latest version of ToTok for Android, and enjoy free video calls.",
        },
        { property: "og:site_name", content: "ToTok" },
      ],
    };
  },
  data() {
    return {
      appInfo: "",
      crumbProp: {
        label: "Recent News",
        type: "simple",
      },
      securityList: [
        {
          label: "CM Security",
          icon: ic_smsecurity,
        },
        {
          label: "Lookout Security",
          icon: ic_lookout,
        },
        {
          label: "McAfee",
          icon: ic_mcafee,
        },
      ],
      downloadTitle: "Download the latest version of ToTok for Android",
      downloadTip: "DOWNLOAD NOW",
      appVersion: "",
      downloadLimitTips:
        "ToTok for Android is also available on Samsung Galaxy Store, Huawei App Gallery, Xiaomi GetApps, and OPPO App Market.",
      downloadSafeSubTips:
        "For secure and privacy protection, any download from unknown sources should be verified with SHA256 checksum displayed here, otherwise you must not install it.",
      appInfoList: "",
    };
  },
  methods: {
    t(d,ar){
      if(this.$route.query.lang == "ar"){
        if(ar != undefined) return ar;
        else return d;
      } else {
        return d;
      }
    },
    viewDownload() {
      //window.gtag("event", "download", {
       // event_category: "official",
        //event_label: "download",
      //});
      window.location.href =
        "https://static2.totok.ai/android/totok-pub-release_v1.9.13(453)_totok.apk";
    },
    viewPage(href, target) {
     // window.gtag("event", "download", {
       // event_category: `${target}`,
       // event_label: "download",
      //});
      if (href.indexOf("https") >= 0) {
        window.location.href = href;
      } else {
        this.$alert(
          '1. Open GetApps on your Xiaomi phone. <br/>2. Search "ToTok" and install it.',
          "Tips",
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "OK",
            cancelButtonText: "Cancel",
          }
        );
      }
    },
    viewTips() {},
    downloadHandle() {
      //window.gtag("event", "download", {
        //event_category: "official",
       // event_label: "download",
     // });
      window.location.href =
        "https://static2.totok.ai/android/totok-pub-release_v1.9.13(453)_totok.apk";
    },
    viewSamsungHandle() {
     // window.gtag("event", "download", {
       // event_category: "Samsung",
       // event_label: "download",
     // });
      window.location.href =
        "https://galaxystore.samsung.com/detail/ai.totok.chat?badge=videocall&session_id=W_42cd90632a74824155ad5624d64ed728";
    },
    viewHuaweiStoreHandle() {
      //window.gtag("event", "download", {
        //event_category: "Huawei",
        //event_label: "download",
     // });
      window.location.href =
        "https://appgallery.cloud.huawei.com/marketshare/app/C101085053?locale=en_US&source=appshare&subsource=C101085053";
    },
    viewXiaomiAppHandle() {
      //window.gtag("event", "download", {
       // event_category: "xiaomi",
       // event_label: "download",
      //});
      this.$alert(
        '1. Open GetApps on your Xiaomi phone. <br/>2. Search "ToTok" and install it.',
        "Tips",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
        }
      );
    },
    viewOppoHandle() {
     // window.gtag("event", "download", {
       // event_category: "Oppo",
        //event_label: "download",
      //});
      this.$alert(
        '1. Open App Market on your OPPO, OnePlus or VIVO phone.<br/>2. Search "ToTok" and install it.',
        "Tips",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
        }
      );
    },
    async getAppInfoList() {
      let res = await axios.get("/appVersion27.json");
      const appInfo = res.data;
      this.appInfo = res.data;
      this.appVersion = appInfo.appVersion;
      this.appInfoList = [
        {
          label: "Platform: ",
          value: appInfo.platform,
        },
        {
          label: "ToTok APK: ",
          value: appInfo.apkName,
        },
        {
          label: "Size: ",
          value: appInfo.size,
        },
        {
          label: "SHA-256 checksum: ",
          value: appInfo.sha256,
        },
      ];
    },
  },
  computed: {
    downloadIconList(){
      return [
        
        {
          imgrul: this.t(ic_download_huawei,ic_download_huawei_ar),
          href:
            " https://appgallery.cloud.huawei.com/marketshare/app/C101085053?locale=en_US&source=appshare&subsource=C101085053",
          imgAlt: "ToTok app download for Huawei devices",
          target: "Huawei",
        },
        {
          imgrul: this.t(ic_galaxystore,ic_galaxystore),
          href:
            "https://galaxystore.samsung.com/detail/ai.totok.chat?badge=videocall&session_id=W_42cd90632a74824155ad5624d64ed728",
          imgAlt: "download ToTok free video call app for Samsung",
          target: "Samsung",
        },
        {
          imgrul: ic_getapps,
          href: `1. Open GetApps on your Xiaomi phone.
                    2. Search "ToTok" and install it.`,
          target: "xiaomi",
        },
        {
          imgrul: ic_apkpure,
          href:
            "https://apkpure.com/totok-free-hd-video-calls-voice-chats/ai.totok.chat",
          imgAlt: "download ToTok apk on apkpure",
          target: "apkpure",
        },
        {
          imgrul: ic_uptodown,
          href:
            "https://totok-free-hd-video-calls-and-voice-chats.en.uptodown.com/android",
          imgAlt: "download free calling app for uae",
          target: "uptodown",
        },
        {
          imgrul: ic_aptoide,
          href: "https://totok.en.aptoide.com/",
          imgAlt: "download ToTok free video calling app",
          target: "aptoide",
        },
      ]
    },
    isPc() {
      return document.body.offsetWidth > 450;
    },
    isIOS() {
      return navigator.userAgent.toLowerCase().indexOf("iphone") >= 0;
    },
  },
  mounted() {
    this.getAppInfoList();
  },
  beforeRouteEnter(to, from, next) {
    if (navigator.userAgent.toLowerCase().indexOf("iphone") >= 0) {
      next("/");
    } else {
      next();
    }
  },
};
</script>

<style lang="stylus" scoped>
.download_wrapper{

    width:100%;
    .notification_box{
        background: #f7fbf5;
        width:100vw;
        padding:40px 0px;
        margin-top:20px;
    }
    .notification_wrapper{
        background: #f7fbf5;
        display: flex;
        width: 100%;
        max-width: 800px;
        margin: 0 auto;
        flex-direction: row;
        justify-content: center;
    .notification_container{
        letter-spacing 0.5px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        width: 462px;
        h3{
            font-family:  "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;;
            font-size: 28px;
            line-height: 45px;
            color: #222;
            margin-bottom: 20px;
            font-weight:400;
        }
        p{
            font-family:  "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;;
            font-size: 13px;
            line-height: 26px;
            font-weight:400;
            color: #555;
            margin-bottom: 1rem;
        }

    }
    .android_download_pic{
            width: 170px;
            height: 369px;
            margin-left: 50px;
            padding-top: 11px;
        }
    }
    .download_tips{
        width: 100%;
        height: 48px;
        background-color: #f8f8f8;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family:  "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;;
        font-size: 15px;
        line-height: 13px;
        letter-spacing: 1px;
        color: #4378f2;
    }
    .download_totok{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        height: 380px;
        background: #fff;
        width: 100%;
        max-width: 800px;
        margin: 0 auto;
      .download_available{
            // background-color: #f2f7ff;
            width: 100%;
            max-width: 400px;
            height: 380px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            letter-spacing:0.5px
            .avaliable_wrapper{
                position relative;
                font-family:  "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;;
                font-size: 16px;
                line-height: 21px;
                color: #808080;
                margin-bottom: 2px;
                &:after{
                  position: absolute;
                  top: 10px;
                  right: -76%;
                  content: '';
                  width: 63%;
                  height: 1px;
                  border-bottom: 1px solid #cccccc;
                }
                &:before{
                  position: absolute;
                  top: 10px;
                  left: -72%;
                  content: '';
                  width: 63%;
                  height: 1px;
                  border-bottom: 1px solid #cccccc;
                }
            }
            .download_icon{
                cursor:pointer;
            }
        ul{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            width: 253px;
            flex-wrap: wrap;
            margin-left: -17%;
            li{
                    width: 79px;
                    margin-top: 8px;
                    margin-right: 8px;
                        margin-bottom: 4px;
                img{
                        // width: 110px;
                    height: 40px;
                    background-color: #000;
                    border-radius: 4px;
                }
            }
        }
        .available_download_label{
            text-align:center;
            padding-bottom: 50px;
            width: 313px;
            margin-top: 25px;
            font-family:  "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;;
            font-size: 15px;
            line-height: 17px;
            color: #808080;
        }

      }
      .download_official{
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 100%;
            max-width:400px;
            height: 380px;
            letter-spacing:0.5px;
            margin-top: 25px;
          .official_img{
            cursor: pointer;
            width: 220px;
            border-radius: 4px;
            margin: 28px 0px;
          }
          .version{
            font-family:  "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;;
            font-size:15px;
            margin-bottom: 10px;
            line-height: 14px;
            color: #808080;
            text-align: center;
          }
          .release_time{
            text-align: center;
            font-family:  "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;;
            font-size: 15px;
            line-height: 18px;
            color: #000;
          }
          .donwload_title{
            font-family:  "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;;
            font-size: 19px;
            line-height: 21px;
            color: #000;
          }
          .donwload_sub_title{
            text-align: center;
            font-size: 19px;
          }
          .donwload_title_mobile{
            font-family:  "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;;
            font-size: 26px;
            text-align: center;
            line-height: 32px;
            font-weight:400;
            width:90%;
            color: #000;
          }
          .official_icon{
            width: 9px;
	        height: 12px;
          }
          .verified_by_wrapper{
            display: flex;
            align-items: center;
            justify-content: center;
            width: 208px;
            font-family:  "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;;
            font-size: 11px;
            margin: 0 auto;
                margin-top: 21px;
                padding-bottom: 3px;
            .verified_by_label{
                
                font-family:  "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;;
                font-size:16px
                letter-spacing: 0px;
                color: #1977d6;
                 padding:5px 0px;
                
             }
          }
          .verified_box{
            padding-bottom: 20px;
            height: 63px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
        .verified_item{
            height: 12px;
            line-height: 12px;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 5px 0;
        .verified_item_img{
            width: 15px;
        }
        .verified_item_label{
            font-size: 16px;
            padding-left:7px;
        }
        }
          }
      }
    }
}

@media only screen and (min-width: 701px) {
    .download_wrapper{
      margin-top:100px;
      .download_tips{
        height:36px;
      }
      .download_totok{
          flex-direction:column;
            height: 690px;
            .download_official{
                  max-width: 490px;
                  height:540px;
              .donwload_title{
                font-size:35px;
                text-align: center;
                line-height: 40px;
              }
            }
      }
    }
}
@media only screen and (max-width: 700px) {
    .download_wrapper{

        .notification_box{
            background: #f7fbf5;
            width: calc(100vw - 60px);
            padding: 30px;
            text-align: left;
             margin-top:0px;
            .notification_wrapper{
                flex-direction: column;
                .notification_container{
                        width: 100%;

                }
                .android_download_pic{
                    width: 100%;
                    max-width: 400px;
                    margin: 20px auto;
                    padding-top: 11px;
                    height auto;
                        }
            }
        }
        .download_totok{
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                 height: 647px;
                background: #fff;
                width: 100%;
                max-width: 800px;
                margin: 0 auto;
                flex-wrap: wrap;
                .download_official{
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    width: 100%;
                    max-width: 400px;
                    height: 360px;
                    letter-spacing:0.5px;
                }
                .download_available{
                      margin-top: 20px;
                    // background-color: #f2f7ff;
                    letter-spacing:0.5px
                    width: 100%;
                    max-width: 400px;
                    height: 270px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                }
            }
            .notification_container{

            }
        }
    }
</style>
<style>
.el-message-box {
  width: 300px !important;
}
.el-button--primary {
  background-color: #4378f2 !important;
  border-color: #4378f2 !important;
}
</style>
